
export const SMOKING_PREF = {
  SMOKING: 'smoking',
  NON_SMOKING: 'nonSmoking'
};

export const GENDER = {
  FEMALE: 0,
  MALE: 1,
  UNANSWERED: -1
};

export const INVITEE_STATUS = {
  ACCEPTED: 2
};

export const ATTENDEE_TYPE_MAPPINGS_BY = {
  ADMISSION_ITEM: 'AdmissionItem',
  REGISTRATION_PATH: 'RegistrationPath'
};

export const REQUEST_STATUS = {
  SUBMITTED: 'SUBMITTED',
  PROCESSING: 'PROCESSING',
  APPROVED: 'APPROVED',
  RESERVED: 'RESERVED',
  DENIED: 'DENIED',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  TICKETED: 'TICKETED'
};

export const REQUEST_DATE_STATUS = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  DENIED: 'DENIED'
};

export const PASSENGER_NAME_CHARS_LIMIT = 100;
export const AIRLINE_CHARS_LIMIT = 50;
export const FLIGHT_NUMBER_CHARS_LIMIT = 10;
export const FLIGHT_COST_CHARS_LIMIT = 10;
export const FLIGHT_SEAT_CHARS_LIMIT = 10;
export const TICKET_CLASS_CHARS_LIMIT = 20;
export const TEXTAREA_CHARS_LIMIT = 300;
export const CONFIRMATION_NUMBER_CHARS_LIMIT = 30;

export const JOURNEY_TYPE = {
  ROUND_TRIP: 1,
  ONE_WAY: 2,
  ONE_WAY_ROUND_TRIP: 3
};

export const JOURNEY_SEGMENT = {
  OUTBOUND: {
    name: 'outbound',
    value: 1
  },
  INBOUND: {
    name: 'inbound',
    value: 2
  }
};

export const FLIGHT_TYPE = {
  DIRECT: 1,
  MULTI_STOP: 2
};

export const AIR_ACTUAL_SOURCE_TYPE = {
  CVENT: 1,
  CONCUR: 2,
  GROUP_FLIGHT: 3
};

export const OTHER_ATTENDEE_REGISTRATION_ID = 'other';

export const ROOMMATE_PREFERENCE_TYPE = {
  ENTER_NAME: 'enterName',
  SELECT_FROM_LIST: 'selectFromList'
};

export const AVAILABLE_ROOMMATES_OPTION = {
  REGISTRANTS: 'registrants',
  INVITEES: 'invitees'
};

export const REG_TYPE_MATCHING_OPTION = {
  SAME_REG_TYPES: 'sameRegTypes',
  SELECTED_REG_TYPES: 'selectedRegTypes'
};

export const ROOMMATE_PREFERENCE_OPTION = {
  VISIBLE: 'visible',
  REQUIRED: 'required'
};

export const ROOMMATE_MATCHING_TYPE = {
  NAME: 'NAME',
  ACCEPT: 'ACCEPT',
  SEARCH: 'SEARCH',
  ENLIST_SELF: 'ENLIST_SELF'
};
